import { kebabCase } from 'lodash-es';

export enum ChapterDatasetKey {
  ID = 'chapterId',
}

export const CHAPTER_ID_DATA_ATTRIBUTE = `data-${kebabCase(
  ChapterDatasetKey.ID,
)}`;
